export const apps = [
    {
        id: 'gnocchi',
        url: 'https://gnocchi.biscuits.club',
        name: 'Gnocchi',
        description: 'Organize your weekly cooking',
        mainImageUrl: 'https://gnocchi.biscuits.club/og-image.png',
        iconPath: 'android-chrome-512x512.png',
        size: 4,
        devOriginOverride: 'http://localhost:6220',
        demoVideoSrc: '/videos/gnocchi-compressed.mp4',
        paidFeatures: [
            {
                imageUrl: '/images/gnocchi/scanner.png',
                title: 'Recipe Scanner',
                description: 'Scan web recipes to create a personal copy. Add notes, make changes, and collaborate on cooking with other plan members.',
            },
            {
                imageUrl: '/images/gnocchi/groceries-collaboration.png',
                title: 'Collaborative Groceries',
                description: 'Share your groceries list with other plan members and stay on the same page. Shopping gets more efficient with realtime presence and progress updates.',
                family: true,
            },
            {
                imageUrl: '/images/gnocchi/recipe-collaboration.png',
                title: 'Sous Chef Mode',
                description: 'Team up with other plan members to cook a recipe together. Assign steps and track progress with instant updates.',
                family: true,
            },
        ],
        paidDescription: 'Your personal cooking app becomes a family groceries list and recipe box.',
        theme: 'lemon',
        domainRoutes: (planId) => `/gnocchi/hub/${planId}`,
    },
    {
        id: 'trip-tick',
        url: 'https://trip-tick.biscuits.club',
        name: 'Trip Tick',
        description: 'The smartest packing list for your next trip',
        iconPath: 'icon.png',
        size: 2,
        devOriginOverride: 'http://localhost:6221',
        demoVideoSrc: '/videos/trip-tick-compressed.mp4',
        paidFeatures: [
            {
                imageUrl: '/images/trip-tick/weather.png',
                title: 'Weather Forecast',
                description: 'Get weather forecasts for your destination over the duration of your trip.',
            },
            {
                imageUrl: '/images/trip-tick/conditions.png',
                title: 'Powerful Conditions',
                description: 'Define conditions for packing list items based on predicted weather to make sure you have everything you need.',
            },
        ],
        paidDescription: 'Now everyone can be on the same page when packing. Plus, get a weather forecast and more powerful trip planning tools.',
        theme: 'eggplant',
    },
    {
        id: 'wish-wash',
        demoVideoSrc: '',
        description: 'TODO',
        devOriginOverride: 'http://localhost:6222',
        iconPath: 'icon.png',
        name: 'Wish Wash',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://wish-wash.biscuits.club',
        prerelease: true,
        theme: 'eggplant',
        domainRoutes: (listId) => `/wish-wash/hub/${listId}`,
    },
    {
        id: 'marginalia',
        demoVideoSrc: '',
        description: 'TODO',
        devOriginOverride: 'http://localhost:6223',
        iconPath: 'icon.png',
        name: 'Marginalia',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://marginalia.biscuits.club',
        prerelease: true,
        theme: 'tomato',
    },
    {
        id: 'star-chart',
        demoVideoSrc: '',
        description: 'TODO',
        devOriginOverride: 'http://localhost:6224',
        iconPath: 'icon.png',
        name: 'Star Chart',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://star-chart.biscuits.club',
        prerelease: true,
        theme: 'blueberry',
    },
    {
        id: 'humding',
        demoVideoSrc: '',
        description: 'An app for playing it by ear',
        devOriginOverride: 'http://localhost:6225',
        iconPath: 'icon.png',
        name: 'Humding',
        paidDescription: 'Share your songs with others and sync to all your devices',
        paidFeatures: [],
        url: 'https://humding.biscuits.club',
        prerelease: true,
        theme: 'lemon',
    },
    {
        id: 'names',
        name: 'Names',
        iconPath: 'icon.png',
        description: "Remember people's names",
        url: 'https://names.biscuits.club',
        devOriginOverride: 'http://localhost:6227',
        demoVideoSrc: '/videos/names-compressed.mp4',
        paidDescription: 'Sync names with your devices and share with family, plus location-based search',
        paidFeatures: [
            {
                imageUrl: '',
                title: 'Location-Based Search',
                description: 'Automatically record where you are when you add a name, so you can search later by where you met someone.',
            },
            {
                imageUrl: '',
                title: 'Family Sharing',
                description: 'Share names with family members so you can all remember together.',
                family: true,
            },
            {
                imageUrl: '',
                title: 'Sync Across Devices',
                description: 'Access your names on all your devices.',
            },
        ],
        prerelease: false,
        theme: 'leek',
    },
    {
        id: 'palette',
        demoVideoSrc: '/videos/palette-compressed.mp4',
        description: 'Paint what you see',
        devOriginOverride: 'http://localhost:6226',
        iconPath: 'icon.png',
        name: 'Palette',
        paidDescription: 'Sync your projects across all your devices',
        paidFeatures: [],
        url: 'https://palette.biscuits.club',
        prerelease: false,
        theme: 'lemon',
    },
    {
        id: 'post',
        description: 'Write and share your thoughts',
        devOriginOverride: 'http://localhost:6228',
        iconPath: 'icon.png',
        name: 'Post',
        paidDescription: 'TODO',
        paidFeatures: [],
        url: 'https://post.biscuits.club',
        prerelease: true,
        theme: 'blueberry',
        domainRoutes: (notebookId) => `/post/hub/${notebookId}`,
        demoVideoSrc: '',
    },
];
export const appIds = apps.map((app) => app.id);
export function isValidAppId(appId) {
    return appIds.includes(appId);
}
export const appsById = Object.fromEntries(apps.map((app) => [app.id, app]));
export function getAppUrl(app) {
    if (import.meta.env.DEV) {
        return app.devOriginOverride;
    }
    return app.url;
}
export const visibleApps = apps.filter((app) => !app.prerelease);
//# sourceMappingURL=index.js.map